import React from "react";
import ScanHand from "../../ScanHand";

const Screen18 = () => {
    return <ScanHand />;
};

export default Screen18;
